import React, {FC} from 'react';
import styled from 'styled-components';

import {AttachmentVisualContentTypesEnum} from '../../../../../models/api/attachmentModel';

/*
 * Props.
 */

interface AttachmentFileIconProps {
  contentType: AttachmentVisualContentTypesEnum;
}

/*
 * Style.
 */

interface IconStyleProps {
  $fileType: AttachmentVisualContentTypesEnum;
}
const StyledIconDiv = styled.div<IconStyleProps>`
  width: 16px;
  height: 16px;
  background-image: url(${(p) => fileTypeIcons[p.$fileType]});
`;

/*
 * Component.
 */

export const AttachmentFileIcon: FC<AttachmentFileIconProps> = ({contentType}) => (
  <StyledIconDiv $fileType={contentType} />
);

/*
 * File type icons.
 */

type FileTypeIcons = {[T in AttachmentVisualContentTypesEnum]: string};
/* eslint global-require: 0 */
export const fileTypeIcons: FileTypeIcons = {
  [AttachmentVisualContentTypesEnum.ARCHIVE]: require('../../../../../assets/images/attachmentArchive16.svg'),
  [AttachmentVisualContentTypesEnum.CALENDAR]: require('../../../../../assets/images/attachmentCalendar16.svg'),
  [AttachmentVisualContentTypesEnum.CODE]: require('../../../../../assets/images/attachmentCode16.svg'),
  [AttachmentVisualContentTypesEnum.EXCEL]: require('../../../../../assets/images/attachmentExcel16.svg'),
  [AttachmentVisualContentTypesEnum.GENERIC]: require('../../../../../assets/images/attachmentGeneric16.svg'),
  [AttachmentVisualContentTypesEnum.IMAGE]: require('../../../../../assets/images/attachmentImage16.svg'),
  [AttachmentVisualContentTypesEnum.AUDIO]: require('../../../../../assets/images/attachmentMusic16.svg'),
  [AttachmentVisualContentTypesEnum.PDF]: require('../../../../../assets/images/attachmentPdf16.svg'),
  [AttachmentVisualContentTypesEnum.POWERPOINT]: require('../../../../../assets/images/attachmentPowerpoint16.svg'),
  [AttachmentVisualContentTypesEnum.TEXT]: require('../../../../../assets/images/attachmentText16.svg'),
  [AttachmentVisualContentTypesEnum.VIDEO]: require('../../../../../assets/images/attachmentVideo16.svg'),
  [AttachmentVisualContentTypesEnum.WORD]: require('../../../../../assets/images/attachmentWord16.svg'),
  [AttachmentVisualContentTypesEnum.GOOGLE_DOCUMENT]: require('../../../../../assets/images/attachmentGoogleDoc16.svg'),
  [AttachmentVisualContentTypesEnum.GOOGLE_SLIDES]: require('../../../../../assets/images/attachmentGoogleSlides16.svg'),
};
